export default __webpack_public_path__ + "media/images/sound-7facbc9619f93ddf1128f8e2a13bc067.svg";